import { c as _c } from "react/compiler-runtime";
import Link from "@/components/DashboardLink";
import type { ComponentProps } from "react";
import { useRoutePrefetchIntent } from "@/hooks/useRoutePrefetchIntent";
type RoutePrefetchLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  href: string;
  /** `false` for org-less redirect stubs; see useRoutePrefetchIntent. */
  prefetchOnIntent?: boolean;
};

/** `next/link` that prefetches its route again on hover and focus. */
export function RoutePrefetchLink(t0) {
  const $ = _c(17);
  let href;
  let onFocus;
  let onMouseEnter;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      href,
      prefetchOnIntent: t1,
      onMouseEnter,
      onFocus,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = onFocus;
    $[3] = onMouseEnter;
    $[4] = props;
    $[5] = t1;
  } else {
    href = $[1];
    onFocus = $[2];
    onMouseEnter = $[3];
    props = $[4];
    t1 = $[5];
  }
  const prefetchOnIntent = t1 === undefined ? true : t1;
  const intent = useRoutePrefetchIntent(prefetchOnIntent ? href : null);
  let t2;
  if ($[6] !== intent || $[7] !== onMouseEnter) {
    t2 = event => {
      onMouseEnter?.(event);
      intent.onMouseEnter();
    };
    $[6] = intent;
    $[7] = onMouseEnter;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== intent || $[10] !== onFocus) {
    t3 = event_0 => {
      onFocus?.(event_0);
      intent.onFocus();
    };
    $[9] = intent;
    $[10] = onFocus;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== href || $[13] !== props || $[14] !== t2 || $[15] !== t3) {
    t4 = <Link href={href} onMouseEnter={t2} onFocus={t3} {...props} />;
    $[12] = href;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}